
import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const getUnconfirmedComments = async () => {
  try {
    const res = await axios.get(
      "https://api.teacher-tool.ir/api/v1/post-comment/unconfirmed",
      {
        headers: {
          "Content-Type": "multipart/formData",
          Authorization: `Bearer ${cookies.get("jwt-auth")}`,
        },
      }
    );
    return res;
  } catch (err) {
    return err.response;
  }
};


export const setUnconfirmeComment = async (id) => {
  try {
    const res = await axios.delete(
      "https://api.teacher-tool.ir/api/v1/post-comment/" + id,
      {
        headers: {
          "Content-Type": "multipart/formData",
          Authorization: `Bearer ${cookies.get("jwt-auth")}`,
        },
      }
    );
    return res;
  } catch (err) {
    return err.response;
  }
};

export const setConfirmeComment = async (id) => {
  try {
    const token = cookies.get("jwt-auth");
    const res = await axios.post(
      "https://api.teacher-tool.ir/api/v1/post-comment/" + id + "/confirm",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return err.response;
  }
};
